/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateStocksRequestStocksInner
 */
export interface CreateStocksRequestStocksInner {
    /**
     * 
     * @type {number}
     * @memberof CreateStocksRequestStocksInner
     */
    stockedContentsQuantity: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateStocksRequestStocksInner
     */
    stockedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateStocksRequestStocksInner
     */
    expiresAt?: Date;
}

/**
 * Check if a given object implements the CreateStocksRequestStocksInner interface.
 */
export function instanceOfCreateStocksRequestStocksInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stockedContentsQuantity" in value;

    return isInstance;
}

export function CreateStocksRequestStocksInnerFromJSON(json: any): CreateStocksRequestStocksInner {
    return CreateStocksRequestStocksInnerFromJSONTyped(json, false);
}

export function CreateStocksRequestStocksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStocksRequestStocksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockedContentsQuantity': json['stocked_contents_quantity'],
        'stockedAt': !exists(json, 'stocked_at') ? undefined : (new Date(json['stocked_at'])),
        'expiresAt': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
    };
}

export function CreateStocksRequestStocksInnerToJSON(value?: CreateStocksRequestStocksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stocked_contents_quantity': value.stockedContentsQuantity,
        'stocked_at': value.stockedAt === undefined ? undefined : (value.stockedAt.toISOString()),
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
    };
}

